import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { refreshProductList } from "../../../../redux/features/productModalSlice";
import { AddProduct } from "../../../../redux/services/ProductService/product.Services";
import { successToast, errorToast } from "../../../../Utils/toast";
import { ActiveUserList } from "../../../../redux/services/User Services/User.Services";
import useDropdownData from "./hooks/useDropdownData";
import useProductForm from "./hooks/useProductForm";
import useProductConfiguration from "./hooks/useProductConfiguration";
import Cookies from "js-cookie"
import ProductFormRenderer from "./ProductFormRenderer";

function CreateProduct({ refreshData }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const form = useProductForm();
    const dropdown = useDropdownData();
      const [vendorCategory, setVendorCategory] = useState(null);
    const [loadingCategory, setLoadingCategory] = useState(true);
    // const config = useProductConfiguration();
    const config = useProductConfiguration(form.formData.subcategory_slug);
    // const config = useProductConfiguration(
    //     form.formData.subcategory_id
    // );
    const admin = useSelector((state) => state.auth.admin);
    const userInfo = admin?.subcategory?.slug || admin?.subcategory?.name || 'Unknown';
    const handleSubmit = async (e) => {
        e.preventDefault();
        const isValid = form.validate();
    
    if (!isValid) {
        console.log("❌ Validation Failed - Errors:", form.errors);
        
        // ✅ Show specific error messages
        const errorMessages = Object.values(form.errors);
        if (errorMessages.length > 0) {
            errorToast(`Please fix: ${errorMessages.join(", ")}`);
        }
        return;
    }

        try {
            form.setIsLoading(true);
            const payload = form.createFormData();
            // for (const pair of payload.entries()) {
            //     console.log(pair[0], pair[1]);
            // }
            const res = await AddProduct(payload);
            if (res?.data?.success) {
                successToast(res.data.message);
                refreshData?.();
                dispatch(refreshProductList());
                navigate("/product-list");
            } else {
                errorToast(res?.data?.message);
            }

        } catch (error) {

            console.log(error);

            errorToast("Failed to create product");

        } finally {

            form.setIsLoading(false);

        }
    };
    // const selectedUser = dropdown.users?.find(
    //     (user) => user.id === Number(form.formData.user_id)
    // );
  useEffect(() => {
        const fetchVendorCategory = async () => {
            try {
                setLoadingCategory(true);
                // const tokenFromCookie = Cookies.get("adminToken");
                const tokenFromCookie = localStorage.getItem("adminToken");
               

                const response = await fetch(
                    `${process.env.REACT_APP_API_BASE_URL}/vendor/vendor-permissions-show`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${tokenFromCookie}`,
                            Accept: "application/json",
                            "Content-Type": "application/json",
                        },
                    }
                );

                const result = await response.json();
                console.log("📦 vendor-permissions-show Response:", result);

                if (
                    result.success &&
                    Array.isArray(result.data) &&
                    result.data.length > 0
                ) {
                    const inventoryEntries = result.data.filter((p) => {
                        const name = p.module?.name?.trim()?.toLowerCase() || "";
                        return name.includes("inventory");
                    });

                    if (inventoryEntries.length === 0) {
                        setVendorCategory(null);
                        return;
                    }

                    const withSubcategory = inventoryEntries.find(
                        (p) => p.subcategory_id
                    );
                    const chosen = withSubcategory || inventoryEntries[0];

                    setVendorCategory({
                        user_id: chosen.user_id,
                        category_id: chosen.category_id,
                        subcategory_id: chosen.subcategory_id,
                        category_slug: chosen.category?.slug,
                        subcategory_slug: chosen.subcategory?.slug,
                        category_name: chosen.category?.name,
                        subcategory_name: chosen.subcategory?.name,
                    });
                } else {
                    setVendorCategory(null);
                }
            } catch (error) {
                console.error("❌ Vendor category fetch failed:", error);
                errorToast("Failed to fetch vendor category");
            } finally {
                setLoadingCategory(false);
            }
        };

        fetchVendorCategory();
    }, []); 
        useEffect(() => {
        if (!vendorCategory) return;

        const autoFill = async () => {
            const { user_id, category_id, subcategory_id, subcategory_slug } =
                vendorCategory;

            const variantConfig = config?.variant_fields || {
                required: [],
                optional: [],
            };
            const allVariantFields = [
                ...variantConfig.required,
                ...variantConfig.optional,
            ];

            const initialVariant = {};
            allVariantFields.forEach((field) => {
                if (field === "color_ids" || field === "size_ids") {
                    initialVariant[field] = [];
                } else {
                    initialVariant[field] = "";
                }
            });

            const hasVariants = config?.components?.variants === true;

            await dropdown.loadSubCategory(category_id);
            await dropdown.loadDynamicDropdowns({
                category_id,
                subcategory_id,
            });

            form.setFormData({
                user_id: String(user_id),
                category_id: String(category_id),
                subcategory_id: String(subcategory_id),
                subcategory_slug: subcategory_slug,
                variants: hasVariants ? [initialVariant] : [],
            });

            console.log("✅ Auto-fill complete:", {
                user_id,
                category_id,
                subcategory_id,
                subcategory_slug,
            });
        };

        autoFill();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [vendorCategory]);
        if (loadingCategory) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary"></div>
                <p className="mt-2">Loading vendor category...</p>
            </div>
        );
    }
    return (
        <div className="main_page">
            <div className="">
                <div className="">
                    <div className="d-flex justify-content-between mb-3">
                        <h4>Add Product</h4>
                        {/* MODIFY THIS SECTION - Add user info */}
                        <div className="d-flex align-items-center gap-3">


                            <button
                                className="add-btn"
                                onClick={() => navigate(-1)}
                            >
                                Back
                            </button>
                            {/* <button className="add-btn">
                                {selectedUser
                                    ? `${selectedUser.name} `
                                    : "Select User"}
                            </button> */}
                        </div>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div className="">
                            <ProductFormRenderer
                                form={form}
                                users={dropdown.users}
                                dropdown={dropdown}
                                autoUserId={vendorCategory?.user_id}  
                                config={config}
                            />

                            <div className="col-md-12">
                                <div className="d-flex justify-content-end gap-2">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={() => navigate(-1)}
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={form.isLoading}
                                    >
                                        {form.isLoading ? "Creating..." : "Create Product"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default CreateProduct;